import React from "react"

const FormSubmissionCreatedAuditItemDetails = () => (
  <div>
    Submitted form.
  </div>
)

export default FormSubmissionCreatedAuditItemDetails
